import { put, select } from "redux-saga/effects";
import {
    disconnectIntegrationFailure,
    disconnectIntegrationSuccess,
    getIntegrationStatusesRequest,
} from "../actionCreators";
import { DisconnectIntegrationRequestActionType } from "../types";
import { IntegrationService } from "../integration.service";

export function* handleDisconnectIntegration(action: DisconnectIntegrationRequestActionType) {
    try {
        const formId: string = yield select(state => state.forms.current._id);
        const { type } = action.payload;

        const { data } = yield IntegrationService.disconnectIntegration(type);

        yield put(disconnectIntegrationSuccess(data));
        if (formId) {
            yield put(getIntegrationStatusesRequest({ formId }));
        }
    } catch (error: any) {
        yield put(
            disconnectIntegrationFailure(
                error.response?.data ? error.response?.data : error.message ? { message: error.message } : error,
            ),
        );
    }
}
